import { render, staticRenderFns } from "./SettingsSMS.vue?vue&type=template&id=26e1222b&"
import script from "./SettingsSMS.vue?vue&type=script&lang=js&"
export * from "./SettingsSMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports